<template>
    <div class="hello-page-wrapper video-player-wrapper bodyfont-unauth">

        <div class="container-fluid" v-if="currentVideo">
            <br>
            <div class="video-player autoheight">
                <div class="left-video-icons"></div>
                <div v-if="currentVideo" class="reset-video-width">
                    <h2 class="text-left">{{currentVideo.title}}</h2>
                    <jwplayer id="mainVideoPlayer" :data="currentVideo">Loading the player...</jwplayer>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <div v-if="videoNotFoundFlag">
            <h3 class="errormessage">This video is for Members only. <br>
                Become a member today by starting your Free Trial</h3>
        </div>
        <!--<div v-if="!videoCompleted" class="container">-->
        <div class="container">
            <div class="row" >
                <div class="col-md-12" v-if="videoTag && videoTag !== 'COMMUNITY'">
                    <div class="player-content" v-if="currentVideo">
                        <p class="video-description">
                            {{currentVideo.Description}}
                        </p>
                        <div class="container-icons vpage" v-if="getCorpButtonColor === '#f0617d'">
                            <social-sharing  v-bind:url = "videoURL" v-bind:media= "videoURL" v-bind:quote = "'TONE Networks | Expert Advice on Demand'" v-bind:description = "currentVideo.Description" v-bind:title = "currentVideo.title" inline-template>
                                <div>
                                    <network network="facebook">
                                        <i class="fa fa-2x fa-facebook cursor"></i>
                                    </network>
                                    <network network="twitter">
                                        <i class="fa fa-2x fa-twitter cursor"></i>
                                    </network>
                                    <network network="linkedin" class="holder">
                                        <i class="fa fa-2x fa-linkedin cursor"></i>
                                    </network>
                                    <network network="email" class="holder">
                                        <i class="fa fa-2x fa-envelope cursor"></i>
                                    </network>
                                </div>
                            </social-sharing>
                        </div>
                        <div class="container-icons vpage" v-if="getCorpButtonColor !== '#f0617d'">
                            <social-sharing  v-bind:url = "videoURL" v-bind:media= "videoURL" v-bind:quote = "'TONE Networks | Expert Advice on Demand'" v-bind:description = "currentVideo.Description" v-bind:title = "currentVideo.title" inline-template>
                                <div>
                                    <network network="facebook" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-facebook cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                    <network network="twitter" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-twitter cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                    <network network="linkedin" class="holder" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-linkedin cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                    <network network="email" class="holder" v-bind:style="{backgroundColor: '#A9A9A9 !important'}">
                                        <i class="fa fa-2x fa-envelope cursor" v-bind:style="{color: '#FFFFFF !important'}"></i>
                                    </network>
                                </div>
                            </social-sharing>
                        </div>
                        <div class="profile-content" v-if="videoExpert">
                            <a :href="'/expert/' + videoExpert[0].expertId + '/' + videoExpert[0].name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" target="_blank">
                                <img v-bind:src="videoExpert[0].small_image" :alt="videoExpert[0].name" :title="videoExpert[0].name">
                                <h4>{{videoExpert && videoExpert[0].name}}</h4>
                                <span>{{videoExpert && videoExpert[0].experties}}</span>
                            </a>
                        </div>
                        <p class="video-text">
                            {{videoExpert && videoExpert[0].areasofexpertise}}
                        </p>
                        <!--<div class="row">-->
                        <!--<div class="col-xs-4 col-sm-4 col-md-4 col-lg-3">-->
                        <!--<button class="btn btn-danger recently-watched-btn btn-transparent btn-lg"-->
                        <!--@click="toggleViewTranscript">-->
                        <!--<span v-show="!viewTranscript">View Transcript</span>-->
                        <!--<span v-show="viewTranscript">Hide Transcript</span>-->
                        <!--</button>-->
                        <!--</div>-->
                        <!--<div class="col-xs-12 col-sm-8 col-md-8 col-lg-9">-->
                        <!--<div class="side-content" v-if="getCurrentVideoTranscript">-->
                        <!--<div v-show="viewTranscript" class="boxes"-->
                        <!--:class="{'animated fadeIn': viewTranscript, 'animated fadeOut': !viewTranscript}"-->
                        <!--&gt;-->
                        <!--<pre><p v-html="getCurrentVideoTranscript.vtt_file">-->
                        <!--</p></pre>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--</div>-->
                        <!--<div class="profile-content" v-if="getExpert">-->
                        <!--<img v-bind:src="getExpert[0].small_image" alt="">-->
                        <!--<h4>{{getExpert[0].name}}</h4>-->
                        <!--<span>{{getExpert[0].experties}}</span>-->
                        <!--</div>-->
                        <!--<p class="video-text">-->
                        <!--{{getExpert[0].biography}}-->
                        <!--</p>-->
                    </div>
                </div>
                <div class="gap clearfix"></div>
                <div class="gap clearfix"></div>
                <h2 v-if="videoTag && videoTag !== 'COMMUNITY'">MORE {{videoTag}} VIDEOS</h2>
                <div class="gap clearfix"></div>
                <div class="row morevediosrow" v-if="videoList">
                    <div class="slider responsive-slick-slider largeslidesilderplayicon">
                        <div class="slide-player" v-for="vid in videoList">
                            <div class="" v-if="videoList">
                                <a :href="'/contentvideos/play/' + vid.mediaid + '/' + vid.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline">
                                <img :src="vid.image" class="jw-img" :alt="vid.title" :title="vid.title"/>
                                <p class="text-wrap-title cursor"> <i class="fa fa-play-circle-o"></i> {{vid.title}}</p>
                                </a>
                            </div>
                        </div>
                        <!--<div class="col-sm-6" v-if="videoList" @click="setVideoPlayerObject(videoList[1].mediaid)">-->
                        <!--<img :src="videoList[1].image" class="jw-img"/>-->
                        <!--<p class="text-wrap-title cursor" @click="setVideoPlayerObject(videoList[1].mediaid)"> <i class="fa fa-play-circle-o"></i> {{videoList[1].title}}</p>-->
                        <!--</div>-->
                    </div>
                </div>
                <div class="gap clearfix"></div>
                <h4 v-if="showComponent">Want more tips ? Sign up today for your free TONE trial!</h4>
                <div class="text-center" v-if="showComponent">
                    <button v-if="!getCorporateGiftingCode" @click="$router.push('/signup')" type="button" class="btn btn-success btn-lg">Start Your Free Trial</button>
                    <button   v-if="getCorporateGiftingCode && getCorporateClient" @click="redeemCode()" type="button" class="btn btn-success btn-lg">{{getCorporateGiftInfo.button_label_01}}</button>
                </div>
                <br>
                <br>
                <div class="container">
                    <div class="tabContent" id="tabs-1" :class="{ current: true }">
                        <div class="">
                            <div class="row yourFaves" v-if="categoryVideoList">
                                <div class="col-md-12">
                                </div>
                                <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" v-for = "video in categoryVideoList">
                                    <img class="jw-img" :src="video.image" @click="triggerLogin(video.mediaid)" :alt="video.title" :title="video.title"  />
                                    <p style="text-align: left;" class="text-wrap-title cursor" @click="triggerLogin(video.mediaid)"> <i class="fa fa-play-circle-o"></i> {{video.title}}</p>
                                    <!--<hr>-->
                                    <!--<p class="right-heart-icon">-->
                                    <!--<a href="javascript:" @click="setVideoStatus(video)" title ="Liked this video?">-->
                                    <!--<i class="fa fa-2x fa-heart-o"-->
                                    <!--v-bind:class="{'activeIcons': getVideoStatus(video)}" aria-hidden="true" ></i></a>-->
                                    <!--</p>-->
                                </div>
                            </div>
                        </div>
                    </div>
                    <h2 v-if="showComponent" class="pink-text-headline" :style="{color: getCorpHeadingColor}"> and many more ...</h2>
                </div>
                <!--<h3 class="pinkheading" v-if="categoryVideoList && videoTag !== 'COMMUNITY'">-->
                <!--More From Our Expert Video Collection-->
                <!--</h3>-->
                <!--<ul class="pinkheading" v-if="categoryVideoList && videoTag !== 'COMMUNITY'">-->
                <!--<li v-for="video in categoryVideoList">-->
                <!--<a href="javascript:" @click="triggerLogin(video.mediaid)">{{video.title}}</a>-->
                <!--</li>-->
                <!--</ul>-->
            </div>
        </div>
        <!--<div class="recently-watched">-->
        <!--<div class="container">-->
        <!--<div class="row" v-if="getAuthRecommendedVideos">-->
        <!--<div class="col-md-12">-->
        <!--<h2>RELATED VIDEOS</h2>-->
        <!--</div>-->
        <!--<div class="col-md-12">-->
        <!--<div class="content">-->
        <!--<div class="slider responsive-slick-slider">-->
        <!--<div v-for = "reccentVideo in recommendationList">-->
        <!--<div class="slide-player">-->
        <!--<img class="jw-img" :src="reccentVideo.image" @click="setVideoPlayerObject(reccentVideo.mediaid)" />-->
        <!--<p class="text-wrap-title">-->
        <!--<i class="fa fa-play-circle-o"></i> {{reccentVideo.title}}-->
        <!--</p>-->
        <!--&lt;!&ndash;<hr>&ndash;&gt;-->
        <!--&lt;!&ndash;<p class="right-heart-icon">&ndash;&gt;-->
        <!--&lt;!&ndash;<i class="fa fa-2x fa-heart-o"&ndash;&gt;-->
        <!--&lt;!&ndash;v-bind:class="{'activeIcons': getVideoStatus(reccentVideo)}" aria-hidden="true" @click=""></i>&ndash;&gt;-->
        <!--&lt;!&ndash;</p>&ndash;&gt;-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="col-md-12">-->
        <!--<button @click="redirectToRelatedVideos()" class="btn btn-danger recently-watched-btn btn-transparent btn-lg">View All Your Videos</button>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
        <!--</div>-->
    </div>
</template>

<script>
    import jwplayer from './JwPlayer.vue'
    import JwPlayList from './JwPlayList.vue'
    import slick from 'slick-carousel'
    import { mapGetters } from 'vuex'
    import store from '../store'
    import $ from 'jquery'

    export default {
        name: 'contentmindbodyplayer',
        components: {
            jwplayer,
            'jwplaylist': JwPlayList
        },
        metaInfo () {
            let self = this
            return {
                title: self.metaTag_pageTitle,
                meta: [
                    {name: 'keywords', content: self.metaTag_keywords},
                    {name: 'description', content: self.metaTag_description},
                    {property: 'og:image', content: self.metaTag_fb_image},
                    {property: 'og:title', content: self.metaTag_fb_title},
                    {property: 'og:site_name', content: self.metaTag_fb_sitename},
                    {
                        property: 'og:description',
                        content: self.metaTag_fb_description
                    },
                    {property: 'twitter:title', content: self.metaTag_tw_title},
                    {property: 'twitter:card', content: 'summary'},
                    {property: 'twitter:image', content: self.metaTag_tw_image},
                    {
                        property: 'twitter:description',
                        content: self.metaTag_tw_description
                    },
                    {property: 'og:image:width', content: '300'},
                    {property: 'og:image:height', content: '300'}
                ]
            }
        },
        data: function () {
            return {
                activeTab: 0,
                currentVideo: '',
                currentStatus: '',
                currentVideoCode: this.$route.params.videoCode,
                recommendationList: '',
                videoCompleted: false,
                videoSqueeze: false,
                hideLeftVideoIcons: false,
                addRightHoverWidthClass: false,
                addIconHoverWidthClass: false,
                showRateHoverBox: false,
                showShareHoverBox: false,
                showEnjoyHoverBox: false,
                addRightHoverEnjoyClass: false,
                addEnjoyHoverClass: false,
                captionTrack: '',
                viewTranscript: false,
                ratingOne: false,
                ratingTwo: false,
                ratingThree: false,
                ratingFour: false,
                hideAll: false,
                videoMessage: '',
                videoMessageIndex: Math.floor(Math.random() * 7),
                videoGif: '',
                videoGifIndex: Math.floor(Math.random() * 4),
                videoURL: window.location.href,
                videoNotFoundFlag: false,
                videoTag: '',
                videoList: '',
                categoryVideoList: null,
                videoExpert: '',
                categoryVideoList24: null,
                metaTag_pageTitle: '',
                metaTag_description: '',
                metaTag_keywords: '',
                metaTag_fb_image: '',
                metaTag_fb_title: '',
                metaTag_fb_description: '',
                metaTag_fb_sitename: '',
                metaTag_tw_image: '',
                metaTag_tw_title: '',
                metaTag_tw_description: '',
                showComponent: false
                // timeoutt: 2000
            }
        },
        methods: {
            setDynamicSection (coll, key) {
                let valCol = coll.filter(x => {
                    return x.content_id === key
                })
                if (valCol && valCol.length > 0) {
                    return valCol[0].content_value
                } else {
                    return ''
                }
            },
            redeemCode () {
                let self = this
                if (self.getCorporateClient.invitationCode === '2') {
                    self.$router.push(`/corporation/referral/buy/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                } else {
                    self.$router.push(`/corporationgifting/${self.getCorporateClientId}/${self.getCorporateGiftingCode}`)
                }
            },
            setVideoPlayerObject (videoCode) {
                this.$router.push(`/contentvideos/play/${videoCode}`)
                location.reload()
            },
            redirectToHome () {
                this.$router.push('/')
            },
            triggerLogin (videoCode) {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', `/watch/${videoCode}`)
                } else {
                    sessionStorage.setItem('redirectPath', `/watch/${videoCode}`)
                }
                store.commit('setTriggerLogin', {loginStatus: true})
            },
            create () {
                $.slick = slick
                const $slick = $(this.$el).find('.responsive-slick-slider')
                $slick.each(function () {
                    // var length = $(this).children().length === 1
//                    console.info(length)
                    $(this).slick({
                        dots: false,
                        infinite: true,
                        speed: 300,
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                infinite: true
                            }
                        }, {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }, {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }]
                    })
                })
            }
        },
        mounted: function () {
            let self = this
            let videoCode = null
            let contentCategory = 'mindbody-promo'
            localStorage.setItem('fromUnauthPage', 'mindbody-promo')
            self.$store.dispatch('GETDYNAMICCONTENTS', 21).then(() => {
                if (self.getAllSiteContents) {
                    // Load Meta Tags
                    this.metaTag_pageTitle = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_PAGE_TITLE')
                    this.metaTag_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_DESCRIPTION')
                    this.metaTag_keywords = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_KEYWORDS')
                    // OpenGraph Tags
                    this.metaTag_fb_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_TITLE')
                    this.metaTag_fb_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_IMAGE')
                    this.metaTag_fb_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_DESCRIPTION')
                    this.metaTag_fb_sitename = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_FACEBOOK_SITENAME')
                    // Twitter Tags
                    this.metaTag_tw_title = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_TITLE')
                    this.metaTag_tw_image = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_IMAGE')
                    this.metaTag_tw_description = this.setDynamicSection(this.getAllSiteContents, 'META_TAG_TWITTER_DESCRIPTION')
                }
            })
//            let allowedCategories = 'work, life, mindbody, money'
//            let validRoute = allowedCategories.toLowerCase().indexOf(contentCategory) // Make sure Its valid route
            if (!self.user) {
                // self.$store.dispatch('GETUNAUTHVIDEOS', 'DEFAULT').then(() => {
                self.$store.dispatch('GETUNAUTHVIDEOS', 'mindbody-promo').then(() => {
                    if (this.getAllUnauthVideos) {
                        if (videoCode) {
                            // verify if this content is for unauthorized users only
//                            let video = this.getAllUnauthVideos.filter(x => {
//                                return x.mediaid === self.$route.params.videoCode && x.tags === contentCategory
//                            })
//                            if (video && video.length > 0) {
//                                let vTag = video[0].tags
//                                let expertId = video[0].expertid
//                                self.videoNotFoundFlag = false
//                                if (vTag.indexOf('work') >= 0) {
//                                    self.videoTag = 'WORK'
//                                    self.videoList = self.getWorkVideo.filter(x => {
//                                        return x.mediaid !== self.$route.params.videoCode
//                                    })
//                                    self.$store.dispatch('GETAUTHVIDEOS', 'WORK').then(() => {
//                                        if (self.getAuthWorkVideos) {
//                                            self.categoryVideoList = self.getAuthWorkVideos
//                                        }
//                                    })
//                                } else if (vTag.indexOf('life') >= 0) {
//                                    self.videoTag = 'LIFE'
//                                    self.videoList = self.getLifeVideos.filter(x => {
//                                        return x.mediaid !== self.$route.params.videoCode
//                                    })
//                                    self.$store.dispatch('GETAUTHVIDEOS', 'LIFE').then(() => {
//                                        if (self.getAuthLifeVideos) {
//                                            self.categoryVideoList = self.getAuthLifeVideos
//                                        }
//                                    })
//                                } else if (vTag.indexOf('money') >= 0) {
//                                    self.videoTag = 'MONEY'
//                                    self.videoList = self.getMoneyVideo.filter(x => {
//                                        return x.mediaid !== self.$route.params.videoCode
//                                    })
//                                    self.$store.dispatch('GETAUTHVIDEOS', 'MONEY').then(() => {
//                                        if (self.getAuthMoneyVideos) {
//                                            self.categoryVideoList = self.getAuthMoneyVideos
//                                        }
//                                    })
//                                } else if (vTag.indexOf('mindbody') >= 0) {
//                                    self.videoTag = 'MINDBODY'
//                                    self.videoList = self.getMindbodyVideo.filter(x => {
//                                        return x.mediaid !== self.$route.params.videoCode
//                                    })
//                                    this.$store.dispatch('GETAUTHVIDEOS', 'MINDBODY').then(() => {
//                                        if (self.getAuthMindbodyVideos) {
//                                            self.categoryVideoList = self.getAuthMindbodyVideos
//                                        }
//                                    })
//                                } else if (vTag.indexOf('community') >= 0) {
//                                    self.videoTag = 'COMMUNITY'
//                                    self.videoList = self.getCommunityVideo.filter(x => {
//                                        return x.mediaid !== self.$route.params.videoCode
//                                    })
//                                    self.videoList = null
//                                    self.categoryVideoList = ''
//                                } else {
//                                    self.categoryVideoList = ''
//                                    self.videoTag = null
//                                    self.videoList = null
//                                }
//                                self.currentVideo = {
//                                    video: video[0].sources[video[0].sources.length - 1].file,
//                                    title: video[0].title,
//                                    img: video[0].image,
//                                    playerID: new Date(),
//                                    tracks: video[0].tracks,
//                                    Description: video[0].description,
//                                    mediaId: video[0].mediaid
//                                }
//                                if (expertId && expertId > 0) {
//                                    self.$store.dispatch('GETEXPERT', expertId).then(() => {
//                                        if (self.getExpert) {
//                                            self.videoExpert = self.getExpert
//                                        }
//                                    })
//                                } else {
//                                    self.videoExpert = null
//                                }
//                            } else {
//                                self.$router.push('/')
//                            }
                        } else { // ELSE PART
                            // verify if this content is for unauthorized users only
                            let video = this.getAllUnauthVideos.filter(x => {
                                return x.tags.indexOf('mindbody-promo') > -1
                            })
                            if (video && video.length > 0) {
                                let vTag = contentCategory
                                let expertId = video[0].expertid
                                self.videoNotFoundFlag = false
                                if (vTag.indexOf('mindbody-promo') >= 0) {
                                    self.videoTag = 'MINDBODY'
                                    self.videoList = self.getMindbodyVideo.filter(x => {
                                        return x.mediaid !== video[0].mediaid
                                    })
                                    setTimeout(() => {
                                        this.create()
                                    }, 1500)
                                    let params = ['MINDBODY', 0]
                                    this.$store.dispatch('GETAUTHVIDEOS', params).then(() => {
                                        if (self.getAuthMindbodyVideos) {
                                            self.categoryVideoList = self.getAuthMindbodyVideos.slice(0, 15)
                                        }
                                    })
                                } else {
                                    self.categoryVideoList = ''
                                    self.videoTag = null
                                    self.videoList = null
                                }
                                self.currentVideo = {
                                    video: video[0].sources[video[0].sources.length - 1].file,
                                    title: video[0].title,
                                    img: video[0].image,
                                    playerID: new Date(),
                                    tracks: video[0].tracks,
                                    Description: video[0].description,
                                    mediaId: video[0].mediaid
                                }
                                self.$store.dispatch('CACHEPAGE', self.videoURL)
                                if (expertId && expertId > 0) {
                                    self.$store.dispatch('GETEXPERT', expertId).then(() => {
                                        if (self.getExpert) {
                                            self.videoExpert = self.getExpert
                                        }
                                    })
                                } else {
                                    self.videoExpert = null
                                }
                            } else {
                                self.$swal({
                                    title: `Video not found or not available for unauthenticated users!`,
                                    text: '',
                                    type: 'error',
                                    timer: 2000,
                                    showCancelButton: false,
                                    showConfirmButton: false
                                }).then(
                                    function () {
                                    },
                                    // handling the promise rejection
                                    function (dismiss) {
                                        if (dismiss === 'timer') {
                                            self.$router.push('/')
                                        }
                                    }
                                )
                            }
                        }
                    }
                })
            } else {
                self.$router.push('/')
            }
            // setTimeout(() => {
            //     this.showComponent = true
            // }, this.timeoutt)
        },
        computed: {
            ...mapGetters([
                'isUserLoggedIn', 'user', 'getWorkVideo', 'getLifeVideos', 'getMoneyVideo', 'getMindbodyVideo', 'getCommunityVideo', 'isScrolled', 'getCurrentVideo', 'getAuthUserVideos', 'getCurrentStatus', 'getAuthRecommendedVideos', 'getExpert',
                'getCurrentVideoTranscript', 'getCurrentVideoDurationWatched', 'getVideEndMessage', 'getVideEndGif', 'getAllUnauthVideos', 'getCorporateGiftingCode', 'getAuthWorkVideos', 'getAuthLifeVideos', 'getAuthMindbodyVideos', 'getAuthMoneyVideos', 'getCorporateClient', 'getCorporateClientId', 'getAllSiteContents', 'getCorpFooterColor', 'getCorpHeadingColor', 'getCorpHeaderColor', 'getCorpButtonColor', 'getCorporateGiftInfo']
            )
        },
        updated () {
            this.showComponent = true
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @media(max-width:768px){
        .row.morevediosrow {
            margin: 0;
        }
    }
    a {
        cursor: pointer !important;
    }
    .video-player-wrapper .watch-again .current-video-img img {
        object-fit: cover;
    }
    .video-player .right-video-icons .enjoy-hover-box {
        width: 20%;
        height: 100%;
        background: #f0617d;
        position: absolute;
        top: 0;
        right: 0;
        padding: 15% 0px 0;
        text-align: left;
    }
    .video-player .right-video-icons .enjoy-hover-box button.btn {
        margin: 0 0 10px;
        border-color: white;
        border-radius: 3px;
        padding: 12px 0 13px;
        display: block;
        width: 80%;
        margin: 0px auto 10px;
        color: #fff;
    }
    .video-player-wrapper .tooltipBox {
        width: 100%;
        text-align: center;
        padding-bottom: 10px;
        height: 35px;
        margin-top: 24px;
    }
    .row.morevediosrow img {
        max-width: 100%;
    }

    .clearfix {
        clear: both;
    }

    .gap {
        height: 30px;
    }
    h3.pinkheading {
        color: #f0617d;
        font-size: 28px;
        letter-spacing: 2px;
        margin: 10px 0 20px;
    }

    ul.pinkheading li  a {}

    ul.pinkheading li {
        margin: 5px 0 5px;
    }

    ul.pinkheading {
        margin: 0;
        padding: 0;
        font-size: 19px;
        font-weight: 900;
        list-style: none;
    }
    /*.row.morevediosrow > div:after {*/
        /*content: "\f04b";*/
        /*font-family: fontawesome;*/
        /*position: absolute;*/
        /*top: 50%;*/
        /*left: 50%;*/
        /*transform: translateX(-50%) translateY(-50%);*/
        /*color: rgba(255, 255, 255, 0.75);*/
        /*font-size: 78px;*/
        /*height: 120px;*/
        /*width: 120px;*/
        /*line-height: 107px;*/
        /*border: 5px solid;*/
        /*border-radius: 50%;*/
        /*text-align: center;*/
        /*padding-left: 22px;*/
        /*cursor: pointer;*/
    /*}*/
    @media (min-width:768px) {
        .video-player .right-video-icons .enjoy-hover-box {
            padding: 117px 0px 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating {
            overflow: hidden;
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
        .video-player .right-video-icons .enjoy-hover-box .rating p {
            color: white;
            display: block;
            font-size: 16px;
            letter-spacing: 0.5px;
            margin-top: 23px;
            margin-bottom: 20px;
            padding: 0 10%;
            text-align: center;
        }
    }
    .video-player .right-video-icons .rate-hover-box span {
        margin-bottom: 20px;
    }
    .video-player .right-video-icons .rate-hover-box button:hover {
        background: #ac2925;
    }
    .video-player .btn-danger:focus {
        background: inherit;
        border-color: inherit;
        outline: none;
    }
    .video-player .right-video-icons div button.btn-danger:hover{
        background:rgba(0,0,0,0.1);
    }
    .video-player .right-video-icons div button.btn-danger.active:hover{
        background:#ac2925;
    }
    .video-player .right-video-icons div button.btn-danger.active:focus{
        color: #fff;
        background-color: #ac2925;
        border-color: #fff;
    }
    .profile-content img {
        object-fit: cover;
        object-position: center center;
    }
    .video-player .left-video-icons {
        background: white;
        color: white;
        width: 15%;
        float: left;
        height: 100%;
    }
    h3.errormessage {
        color: #f0617d;
        letter-spacing: 3px;
        margin: 70px 20px;
    }
    @media(max-width:767px){
        .row.morevediosrow img {
            margin: 0 0 10px;
        }
    }
    .row.morevediosrow p.text-wrap-title.cursor {
        font-size: 20px;
        text-align: left;
        color: #000;
    }
    .container-icons > div > span {
        display: inline-block;
        background: #f0617d;
        height: 50px;
        width: 50px;
        color: #fff;
        text-align: center;
        line-height: 60px;
        border-radius: 50%;
    }
    p.text-wrap-title.cursor {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    h2.pink-text-headline {
        margin: 30px 0 30px;
    }
    p.video-description {
        font-size: 23px;
    }

    .row.morevediosrow p.text-wrap-title.cursor {
        font-size: 20px;
    }

    .tabContent p.text-wrap-title.cursor {
        font-size: 17px;
    }
</style>
<style>
    .container-icons.vpage > div > span {
        display: inline-block;
        background: #f0617d;
        height: 50px;
        width: 50px;
        color: #fff;
        text-align: center;
        line-height: 60px;
        border-radius: 50%;
    }
    .container-icons.vpage {
        text-align: right;
    }
    @media(min-width:320px) and (max-width:767px){
        .video-player.autoheight {
            height: auto;
        }

        .autoheight.video-player .jwplayer.jw-flag-aspect-mode {
            height: auto !important;
        }
    }

    .autoheight div.jw-error.jw-reset {
        height: 25vw !important;
    }
    .video-player .left-video-icons{
        height: 25vw !important;
    }
    .autoheight{
        height: auto !important;
        padding-bottom:20px;
    }
</style>



// WEBPACK FOOTER //
// MindbodyContents.vue?490d3314